import { useState, useEffect, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import SkeletonLoad from "../../components/Skeleton/SkeletonLoad";
import PageHeader from "../../components/PageHeader/PageHeader";

import Tables from "../../components/Table/Tables";
import { payCustomerPaymentCols } from "../../utils/cols";
import moment from "moment";
import { dateChecker } from "../../components/CheckDate/checkDate";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { useHistory, Link } from "react-router-dom";
import { CaretRightOutlined, PlusOutlined, FilterFilled, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, DatePicker, Collapse, Row, Col } from "antd";
import { CSVLink } from "react-csv";
import { getAdminPaymentTypes } from "../../redux/actions/adminPaymentType.action";
import { getRights } from "../../redux/actions/userRights.action";
import jsPDF from "jspdf";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import numeral from "numeral";
import { generateDynamicPDF } from "../../utils/generateDynamicPDF";
import { getAllModaProduct } from "../../redux/actions/modaProductForm.action";

export default function ModaProductFormList({ token }) {
	const [form] = Form.useForm();
	const [dateOP, setDateOP] = useState("");
	const [userRights, setUserRights] = useState({})
	const history = useHistory();
	const dispatch = useDispatch();
	const { Option } = Select;
	const dateFormat = "MM-DD-YYYY";
	const { payCustomerPaymentHeaderList, adminPaymentType, modaProduct } = useSelector((state) => state);
	const [menuId, setMenuId] = useState(408);



	const worker = {
		customer: null,
		from_date: moment().subtract(1, 'year').startOf('year'),
		to_date: moment().endOf('year'),
		paymentNo: null,
		postingPeriod: null,
		arAccount: null,
		debitAccount: null,
		paymentTerm: null,
		paymentType: null,
		paymentMethod: null,
		genderCategory: null,
	};

	const { Panel } = Collapse;
	const onFinishFilter = async (e) => {
		await form.validateFields().then((values) => {
			dateChecker(values.from_date, values.to_date, "paymentHeaderList", token, values, dispatch);

		})
	};

	function downloadExcelFileData(data) {
		if (data) {
			return data.map((v) => {
				return {
					"Item Id": v.item_id,
					"Category": v.category,
					"Shop Sku": v.shop_sku,
					"Title": v.title,
					"Designer": v.designer,
					"Variant Group Code": v.variant_group_code,
					"Vendor Color": v.vendor_color,
					"Main Image": v.main_image,
					"Description": v.description,
					"Tariff Code": v.tariff_code,
					"Item Number Identifier": v.item_number_identifier,
					"Color": v.color,
					"Season": v.season,
					"Country Of Origin": v.country_of_origin,
					"Item Number Identifier Type": v.item_number_identifier_type,
					"Customer Delivery Notes": v.customer_delivery_notes,
					"Made To Order": v.made_to_order,
					"Variant Style Code": v.variant_style_code,
					"Detail Bullets": v.detail_bullets,
					"Material": v.material,
					"Image 2": v.image_2,
					"Image 3": v.image_3,
					"Image 4": v.image_4,
					"Image 5": v.image_5,
					"Image 6": v.image_6,
					"Image 7": v.image_7,
					"Sizes Clothing": v.sizes_clothing,
					"Fit Information": v.fit_information,
					"Sku": v.sku,
					"Product Id": v.product_id,
					"Product Id Type": v.product_id_type,
					"Offer Description": v.offer_description,
					"Internal Description": v.internal_description,
					"Price": v.price,
					"Price Additional Info": v.price_additional_info,
					"Quantity": v.quantity,
					"Min Quantity Alert": v.min_quantity_alert,
					"State": v.state,
					"Available Start Date": v.available_start_date,
					"Available End Date": v.available_end_date,
					"Discount Price": v.discount_price,
					"Discount Start Date": v.discount_start_date,
					"Discount End Date": v.discount_end_date,
					"Update Delete": v.update_delete,
					"Retail Price": v.retail_price
				};
			});
		}
	}

	useEffect(() => {
		dispatch(getAllModaProduct(token))
	}, [])



	useLayoutEffect(() => {
		dispatch(getRights(token, menuId)).then((res) => {
			if (res.type === "GET_USER_RIGHTS_SUCCESS") {
				setUserRights(res?.payload)
			}
		});
	}, [token])

	const generatePDF = () => {
		const columns = ["#", "Payment Header No", "Payment Date", "Customer", "Payment Amount", "Payment Term"];
		const rows = [];
		const sortedData = payCustomerPaymentHeaderList?.payload?.data || [];

		sortedData.forEach((item, index) => {
			const paymentAmount = parseFloat(item.applied) || parseFloat(item.payment_amount) || 0;
			const row = [
				index + 1,
				item.payment_header_no,
				moment(item.payment_date).format("MM-DD-YYYY"),
				item.customer_name,
				"$" + numeral(paymentAmount).format("0,00.00"),
				item.term_name
			];
			rows.push(row);
		});

		generateDynamicPDF({
			orientation: 'portrait',
			filename: "Customer-Payment.pdf",
			columns,
			rows,
			rowsRaw: sortedData,
			totalFields: ['payment_amount'], // if you're summing applied, you can also use 'applied'
			currencyFields: ['payment_amount'],
			totalFieldIndexes: {
				payment_amount: 4 // ✅ Total will appear under "Payment Amount"
			},
			totalLabel: 'Total:',
			totalLabelIndex: 3, // ✅ Under "Customer"
			rightAlignIndexes: [4],
			headers: [],
			margin: { top: 2, left: 5, right: 5, bottom: 2 }
		});
	};


	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
		}) => (
			<Input
				autoFocus
				allowClear
				className="pop-search-gen pop-170"
				placeholder="Type text here"
				value={selectedKeys[0]}
				onChange={(e) => {
					setSelectedKeys(e.target.value ? [e.target.value] : []);
					confirm({ closeDropdown: false });
				}}
				onPressEnter={() => confirm()}
				onBlur={() => confirm()}
			/>
		),

		filterIcon: (filtered) =>
			filtered ? <FilterFilled /> : <SearchOutlined />,

		onFilter: (value, record) =>
			String(record?.[dataIndex] || "")
				.toLowerCase()
				.includes(value.toLowerCase()),

		sorter: (a, b) => {
			const valA = a?.[dataIndex];
			const valB = b?.[dataIndex];

			if (!isNaN(valA) && !isNaN(valB)) {
				return Number(valA) - Number(valB);
			}

			return String(valA || "").localeCompare(String(valB || ""));
		},
	});

	const commonRender = (text, record) => (
		<Link to={`/moda-product/edit/${record.item_id}?edit=yes`}>
			{text || "-"}
		</Link>
	);

	let productCols = [
		{
			title: "Item Id",
			dataIndex: "item_id",
			key: "item_id",
			width: 100,
			render: commonRender,
			...getColumnSearchProps("item_id"),
		},
		{
			title: "Category",
			dataIndex: "category",
			key: "category",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("category"),
		},

		{
			title: "Shop SKU",
			dataIndex: "shop_sku",
			key: "shop_sku",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("shop_sku"),
		},

		{
			title: "Title",
			dataIndex: "title",
			key: "title",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("title"),
		},

		{
			title: "Designer",
			dataIndex: "designer",
			key: "designer",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("designer"),
		},

		{
			title: "Variant Group Code",
			dataIndex: "variant_group_code",
			key: "variant_group_code",
			width: 140,
			render: commonRender,
			...getColumnSearchProps("variant_group_code"),
		},

		{
			title: "Vendor Color",
			dataIndex: "vendor_color",
			key: "vendor_color",
			width: 140,
			render: commonRender,
			...getColumnSearchProps("vendor_color"),
		},

		{
			title: "Main Image",
			dataIndex: "main_image",
			key: "main_image",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("main_image"),
		},

		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("description"),
		},

		{
			title: "Tariff Code",
			dataIndex: "tariff_code",
			key: "tariff_code",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("tariff_code"),
		},

		{
			title: "Item Number Identifier",
			dataIndex: "item_number_identifier",
			key: "item_number_identifier",
			width: 200,
			render: commonRender,
			...getColumnSearchProps("item_number_identifier"),
		},

		{
			title: "Color",
			dataIndex: "color",
			key: "color",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("color"),
		},

		{
			title: "Season",
			dataIndex: "season",
			key: "season",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("season"),
		},

		{
			title: "Country Of Origin",
			dataIndex: "country_of_origin",
			key: "country_of_origin",
			width: 160,
			render: commonRender,
			...getColumnSearchProps("country_of_origin"),
		},

		{
			title: "Identifier Type",
			dataIndex: "item_number_identifier_type",
			key: "item_number_identifier_type",
			width: 200,
			render: commonRender,
			...getColumnSearchProps("item_number_identifier_type"),
		},

		{
			title: "Customer Delivery Notes",
			dataIndex: "customer_delivery_notes",
			key: "customer_delivery_notes",
			width: 200,
			render: commonRender,
			...getColumnSearchProps("customer_delivery_notes"),
		},

		{
			title: "Made To Order",
			dataIndex: "made_to_order",
			key: "made_to_order",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("made_to_order"),
		},

		{
			title: "Variant Style Code",
			dataIndex: "variant_style_code",
			key: "variant_style_code",
			width: 200,
			render: commonRender,
			...getColumnSearchProps("variant_style_code"),
		},

		{
			title: "Detail Bullets",
			dataIndex: "detail_bullets",
			key: "detail_bullets",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("detail_bullets"),
		},

		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("material"),
		},

		{
			title: "Image 2",
			dataIndex: "image_2",
			key: "image_2",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_2"),
		},

		{
			title: "Image 3",
			dataIndex: "image_3",
			key: "image_3",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_3"),
		},

		{
			title: "Image 4",
			dataIndex: "image_4",
			key: "image_4",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_4"),
		},

		{
			title: "Image 5",
			dataIndex: "image_5",
			key: "image_5",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_5"),
		},

		{
			title: "Image 6",
			dataIndex: "image_6",
			key: "image_6",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_6"),
		},

		{
			title: "Image 7",
			dataIndex: "image_7",
			key: "image_7",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("image_7"),
		},

		{
			title: "Sizes Clothing",
			dataIndex: "sizes_clothing",
			key: "sizes_clothing",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("sizes_clothing"),
		},

		{
			title: "Fit Information",
			dataIndex: "fit_information",
			key: "fit_information",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("fit_information"),
		},

		{
			title: "SKU",
			dataIndex: "sku",
			key: "sku",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("sku"),
		},

		{
			title: "Product ID",
			dataIndex: "product_id",
			key: "product_id",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("product_id"),
		},

		{
			title: "Product ID Type",
			dataIndex: "product_id_type",
			key: "product_id_type",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("product_id_type"),
		},

		{
			title: "Offer Description",
			dataIndex: "offer_description",
			key: "offer_description",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("offer_description"),
		},

		{
			title: "Internal Description",
			dataIndex: "internal_description",
			key: "internal_description",
			width: 160,
			render: commonRender,
			...getColumnSearchProps("internal_description"),
		},

		{
			title: "Price",
			dataIndex: "price",
			key: "price",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("price"),
		},

		{
			title: "Price Additional Info",
			dataIndex: "price_additional_info",
			key: "price_additional_info",
			width: 180,
			render: commonRender,
			...getColumnSearchProps("price_additional_info"),
		},

		{
			title: "Quantity",
			dataIndex: "quantity",
			key: "quantity",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("quantity"),
		},

		{
			title: "Min Quantity Alert",
			dataIndex: "min_quantity_alert",
			key: "min_quantity_alert",
			width: 160,
			render: commonRender,
			...getColumnSearchProps("min_quantity_alert"),
		},

		{
			title: "State",
			dataIndex: "state",
			key: "state",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("state"),
		},

		{
			title: "Available Start",
			dataIndex: "available_start_date",
			key: "available_start_date",
			width: 180,
			render: commonRender,
			...getColumnSearchProps("available_start_date"),
		},

		{
			title: "Available End",
			dataIndex: "available_end_date",
			key: "available_end_date",
			width: 180,
			render: commonRender,
			...getColumnSearchProps("available_end_date"),
		},

		{
			title: "Discount Price",
			dataIndex: "discount_price",
			key: "discount_price",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("discount_price"),
		},

		{
			title: "Discount Start",
			dataIndex: "discount_start_date",
			key: "discount_start_date",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("discount_start_date"),
		},

		{
			title: "Discount End",
			dataIndex: "discount_end_date",
			key: "discount_end_date",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("discount_end_date"),
		},

		{
			title: "Update Delete",
			dataIndex: "update_delete",
			key: "update_delete",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("update_delete"),
		},

		{
			title: "Retail Price",
			dataIndex: "retail_price",
			key: "retail_price",
			width: 120,
			render: commonRender,
			...getColumnSearchProps("retail_price"),
		},




	];


	return (
		<div className="styleContainer">
			<div className="styleBody h-100">
				<PageHeader title={"Moda Product List"} />
				<div className="bodyStyle">
					<Collapse
						style={{ width: "100%", padding: "10px" }}
						bordered={false} defaultActiveKey={["1"]}
						expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
						<Panel
							header="Filters"
							key="1"
							className="site-collapse-custom-panel"
							extra={
								<Button
									disabled={userRights.can_add === true ? false : true}
									onClick={() => history.push("/moda-product/add")}
									className="iconBtn crudBTN"
									shape="circle"
									icon={<PlusOutlined />}
								/>
							}
						>

						</Panel>
					</Collapse>
					{modaProduct.loading ? (
						<div className="mainProductContainer">
							<SkeletonLoad />
						</div>
					) : (
						<div className="mainProductContainer">
							<div style={{ padding: 10 }}>

								{
									modaProduct?.payload?.data?.length > 0 && (
										<>
											<div style={{ display: "flex", justifyContent: "left", marginBottom: "5px" }}>
												<div className="print_icon printing_class" >
													<CSVLink
														filename={"Moda-Product-list.csv"}
														data={downloadExcelFileData(modaProduct?.payload?.data) || []}
														onClick={() => {
														}}
													>
														Download Excel
													</CSVLink>
												</div>

											</div>
										</>
									)
								}
								<Tables
									loadHeight={40}
									loadWidth={40}
									type={"customer"}


									scroll={{ x: "max-content" }}
									perPage={25}
									scrollX={"80rem"}
									col={productCols}
									source={modaProduct?.payload?.data || []}
									load={modaProduct.loading}
									paginate
								/>
								{/* <span className="records-text">
                      {dataLen === 0 ? <>No of Records:  <span className="fw-500">  0</span> </> : < > No of Records: <span className="fw-500"> {show ? dataLen : dataLen ? dataLen : "0"}</span>  </>}
                    </span> */}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
